<img
  class="badge"
  alt="badge"
  sharedTextDirection
  [src]="imgSrc()"
  (click)="badgeClick.emit()" />
